import {
  AddToCartButton,
  PriceInfo,
  ProductDetailsContext,
  ProductRequestInfo,
  QuantitySelector,
} from '@components';
import { useAuth } from '@hooks';
import { Stack, styled } from '@mui/material';
import { checkIfExpired, ErpStatus, getErpStatus } from '@utils/products.utils';
import { useContext, useState } from 'react';
import { ProductAddToWishlist } from './ProductAddToWishlist';

type ProductPriceInfoProps = {
  requestInfoEnabled?: boolean;
};

const CartWrapper = styled(Stack)`
  .MuiButton-root {
    min-width: 0 !important;
  }
`;

export const ProductPriceInfo = ({ requestInfoEnabled }: ProductPriceInfoProps) => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { isDealerUser, isBeremaUser, isAuthenticated } = useAuth();
  const [quantity, setQuantity] = useState(1);
  const erpStatus = getErpStatus(product.itemERPItemStatus as string) as ErpStatus;
  const isExpired = checkIfExpired(erpStatus);
  const shouldDisplayAddToCart =
    isAuthenticated && !isExpired && !isBeremaUser && product?.discountPrice?.amount;
  return (
    <>
      <PriceInfo
        isExpired={isExpired}
        grossPrice={product.grossPrice}
        discountPrice={product.discountPrice}
        sx={{
          '& .your-price-wrapper': {
            fontSize: '24px',
          },
        }}
      />

      {shouldDisplayAddToCart ? (
        <Stack spacing={2}>
          <CartWrapper direction='row' spacing={2}>
            <QuantitySelector quantity={quantity} setQuantity={setQuantity} />
            <AddToCartButton
              code={product.code}
              name={product.name}
              showLabel
              quantity={quantity}
              size='large'
            />
          </CartWrapper>

          {requestInfoEnabled && <ProductRequestInfo />}
          {isDealerUser && <ProductAddToWishlist />}
        </Stack>
      ) : null}
    </>
  );
};
